export const SEARCH_REPORT_EXPORT_ENDPOINT = "api/v1/analytics/exportSearchReport";

/**
 * Map UI sort fields to API sortField/sortBy for export (match each report page).
 * @param {string} reportKey
 * @param {string|null|undefined} sortField
 */
export const mapExportSortField = (reportKey, sortField) => {
	if (!sortField) return "";

	if (reportKey === "zeroResultQueries") {
		const m = {
			query: "searchQuery",
			volume: "searchVolume",
			zeroResultSession: "zeroResultPercentage",
		};
		return m[sortField] || sortField;
	}

	if (reportKey === "searchTerms" || reportKey === "noResults") {
		if (sortField === "name") return "_id";
		return sortField;
	}

	if (
		reportKey === "lowProductPageView" ||
		reportKey === "highIntent"
	) {
		const m = {
			query: "searchQuery",
			volume: "searchVolume",
			clicks: "clicks",
			addToCartRate: "addToCartRate",
			ctr: "ctr",
			conversionRate: "conversionRate",
		};
		return m[sortField] || sortField;
	}

	return sortField;
};
